import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, ChangePhoneRequest, Individual } from '@aslanpay/portal-common-lib';

const useChangePhoneNumber = ({
  onSuccess,
  onError,
}: UseMutationOptions<Individual, Error, ChangePhoneRequest>) => {
  return useMutation<Individual, Error, ChangePhoneRequest>(
    ({ phoneNumber, transactionId, code }: ChangePhoneRequest) =>
      individualsService.changePhoneNumber({ phoneNumber, transactionId, code }),
    { onSuccess, onError }
  );
};

export default useChangePhoneNumber;
